<template>
  <v-card class="mx-auto" flat>
    <div class="grey lighten-5">
      <v-container>
        <div class="text-h5 font-weight-medium">
          Evaluasi Kinerja
          <span class="indigo--text">
            {{ $getDeepObj(detail, 'psp_kinerja_sasaran.m_kinerja_fungsi_sasaran.keterangan') }}
          </span>
        </div>
        <v-list three-line class="grey lighten-5 py-0">
          <v-list-item class="px-0">
            <v-list-item-avatar class="mr-3 mt-5">
              <v-avatar color="indigo lighten-1" width="100px">
                <v-icon dark>mdi-account</v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content class="py-0">
              <v-row>
                <v-col cols="12" lg="4">
                  <v-row v-for="(item, id) in info" :key="id" no-gutters style="flex-wrap: nowrap" class="my-1">
                    <v-col
                      style="min-width: 120px"
                      class="flex-grow-0 flex-shrink-0 mr-2 grey--text text--darken-1 body-2"
                    >
                      {{ item.label }}
                    </v-col>
                    <v-col
                      style="max-width: 100%"
                      :class="[
                        'flex-grow-1 flex-shrink-0 text-justify',
                        item.key === 'nama' ? 'font-weight-medium' : '',
                      ]"
                    >
                      {{ item.value }}
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" lg="4">
                  <div class="body-2 grey--text text--darken-1 mb-1">Nama Penilai</div>
                  <div class="font-weight-medium">{{ ptk.nama || akun.nama || '-' }}</div>
                  <div class="body-2">
                    {{ $getDeepObj(ptk, 'ptk_sekolah.sekolah.nama') || $getDeepObj(instansi, 'nama') }}
                  </div>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-container>
    </div>
    <v-divider />
    <v-container>
      <v-list>
        <template v-if="$getDeepObj(instrumenAtKelompok[0], 'kelompok') === 'Z'">
          <v-list-item>
            <div>
              <h3 v-html="$stringToHtml($getDeepObj(instrumenAtKelompok[0], 'keterangan'))"></h3>
            </div>
          </v-list-item>
          <v-list-item>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="form[instrumenAtKelompok[0]['k_kinerja_instrumen_psp']]"
                  :readonly="!isEdit"
                  outlined
                  :placeholder="
                    `Tuliskan keterangan/informasi tambahan terkait ${
                      isInstrumenFsp ? 'FSP' : 'KFSP'
                    } yang belum ada di instrumen dan dirasa penting untuk disampaikan. Minimal 10 kata.`
                  "
                  rows="4"
                  auto-grow
                  :hint="
                    `Tuliskan keterangan/informasi tambahan terkait ${
                      isInstrumenFsp ? 'FSP' : 'KFSP'
                    } yang belum ada di instrumen dan dirasa penting untuk disampaikan. Minimal 10 kata.`
                  "
                  counter="100"
                  :counter-value="(v) => this.$wordCount(v)"
                />
              </v-col>
            </v-row>
          </v-list-item>
        </template>
        <template v-else>
          <v-list-item class="px-0">
            <v-row>
              <v-col cols="12" lg="7" class="my-auto">
                <h2>
                  {{ $getDeepObj(instrumenAtKelompok[0], 'nama_kelompok') }}
                </h2>
              </v-col>
              <v-col cols="12" lg="5" class="my-auto hidden-md-and-down">
                <v-row style="flex-wrap: nowrap">
                  <v-col
                    v-for="(opt, id) in opsiAtKelompok"
                    :key="id"
                    cols="1"
                    style="max-width: 100%"
                    class="flex-grow-1 flex-shrink-0 text-center font-weight-medium"
                  >
                    {{ opt.keterangan }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-list-item>
          <v-list-item v-for="(instrumen, id) in instrumenAtKelompok" :key="id" class="mb-2 px-0">
            <v-row :class="[error[instrumen.k_kinerja_instrumen_psp] ? 'red lighten-5' : '']">
              <v-col cols="12" lg="7" class="pb-0 pb-lg-3 my-auto">
                <v-row no-gutters style="flex-wrap: nowrap">
                  <v-col
                    style="min-width: 25px; max-width: 100%"
                    class="flex-grow-0 flex-shrink-0 text-right mr-2 text-right"
                  >
                    {{ instrumen.urutan }}.
                  </v-col>
                  <v-col style="max-width: 100%" class="flex-grow-1 flex-shrink-0 text-justify">
                    <span v-html="$stringToHtml(instrumen.keterangan)"></span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" lg="5" class="pt-0 py-lg-3">
                <v-row no-gutters>
                  <v-col v-for="(opt, id) in opsiAtKelompok" :key="id" cols="11" offset="1" offset-lg="0" lg="3">
                    <v-radio-group
                      row
                      class="justify-center justify-sm-start justify-lg-center mt-0"
                      hide-details
                      v-model="form[instrumen.k_kinerja_instrumen_psp]"
                    >
                      <v-radio
                        :readonly="!isEdit"
                        class="text-center mx-lg-auto"
                        label=""
                        :value="opt.k_kinerja_opsi_psp"
                      >
                        <template v-slot:label>
                          <div class="hidden-lg-and-up ma-1">{{ opt.keterangan }}</div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <div class="grey--text body-2 text-center hidden-md-and-down">
                      {{ singkat[opt.keterangan] }}
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-list-item>
        </template>
        <v-list-item class="mt-5">
          <v-row>
            <v-col cols="12" class="text-right">
              <v-btn v-if="page > 1" depressed text @click="onPrev">
                <v-icon v-if="page > 1" left class="mr-1">mdi-chevron-left</v-icon>
                Sebelumnya
              </v-btn>
              <v-btn depressed color="primary" class="text-capitalize" @click="onNext">
                {{ page === kelompoks.length ? (isEdit ? 'Simpan' : 'Selesai') : 'Selanjutnya' }}
                <v-icon v-if="page !== kelompoks.length" right class="ml-1">mdi-chevron-right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-list-item>
      </v-list>
    </v-container>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'KinerjaInstrumen',
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    instrumen: {
      type: Array,
      default: () => [],
    },
    kelompokInstrumen: {
      type: Object,
      default: () => {},
    },
    kinerja: {
      type: Object,
      default: () => {},
    },
    jawaban: {
      type: Object,
      default: () => {},
    },
    page: {
      type: Number,
      default: 1,
    },
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      error: {},
      form: {},
      singkat: {
        'Sangat Sesuai': 'SS',
        Sesuai: 'S',
        'Cukup Sesuai': 'CS',
        'Tidak Sesuai': 'TS',
      },
      jenisInstrumen: {
        'fsp-kfsp-a3': 'Penilaian FSP Angkatan 3',
        'fsp-kfsp-a12': 'Penilaian FSP Angkatan 1 dan/atau Angkatan 2',
        'fsp-ks-a3': 'Penilaian FSP Angkatan 3',
        'fsp-ks-a12': 'Penilaian FSP Angkatan 1 dan/atau Angkatan 2',
        'kfsp-fsp-a3': 'Penilaian KFSP Angkatan 3',
        'kfsp-fsp-a12': 'Penilaian KFSP Angkatan 1 dan/atau Angkatan 2',
        'kfsp-satker-a3': 'Penilaian KFSP Angkatan 3',
        'kfsp-satker-a12': 'Penilaian KFSP Angkatan 1 dan/atau Angkatan 2',
      },
    };
  },
  computed: {
    ...mapState('preferensi', {
      ptk: (state) => state?.data?.ptk ?? {},
      akun: (state) => state?.data?.akun ?? {},
      instansi: (state) => state?.data?.instansi ?? {},
    }),

    kelompoks() {
      return Object.keys(this.kelompokInstrumen);
    },

    instrumenAtKelompok() {
      const kelompok = this.kelompoks[this.page - 1];
      return this.kelompokInstrumen[kelompok] || [];
    },

    opsi() {
      return this.instrumen['opsi'] || {};
    },

    opsiAtKelompok() {
      return this.$getDeepObj(this.instrumenAtKelompok[0], 'opsi') || [];
    },

    info() {
      return [
        { key: 'nama', label: 'Nama', value: this.detail.nama_sasaran || '' },
        { key: 'termin', label: 'Termin', value: this.detail.kinerja_ke || '' },
        {
          key: 'instrumen',
          label: 'Jenis Instrumen',
          value: this.jenisInstrumen[this.$getDeepObj(this.detail, 'psp_kinerja_sasaran.instrumen')],
        },
      ];
    },

    isInstrumenFsp() {
      return ['fsp-kfsp-a3', 'fsp-kfsp-a12', 'fsp-ks-a3', 'fsp-ks-a12'].includes(
        this.$getDeepObj(this.detail, 'psp_kinerja_sasaran.instrumen')
      );
    },

    namaKelompok() {
      return String.fromCharCode(this.page + 64);
    },
  },
  methods: {
    reset() {
      this.$set(this, 'error', {});
      this.$set(this, 'form', {});

      for (const ins of this.instrumenAtKelompok) {
        this.$set(this.error, ins.k_kinerja_instrumen_psp, false);
        this.$set(this.form, ins.k_kinerja_instrumen_psp, this.jawaban[ins.k_kinerja_instrumen_psp]);
      }
    },

    validate() {
      for (const ins of this.instrumenAtKelompok) {
        this.$set(this.error, ins.k_kinerja_instrumen_psp, !this.form[ins.k_kinerja_instrumen_psp]);

        if (!this.error[ins.k_kinerja_instrumen_psp] && ins.kelompok === 'Z') {
          this.$set(
            this.error,
            'kelompok-z',
            this.$wordCount(this.form[ins.k_kinerja_instrumen_psp] || '') < 10 ||
              this.$wordCount(this.form[ins.k_kinerja_instrumen_psp] || '') > 100
          );
        }
      }
    },

    getValue() {
      let instrumen = [];
      for (const ins of this.instrumenAtKelompok) {
        let jawaban = { k_kinerja_instrumen_psp: ins.k_kinerja_instrumen_psp };
        jawaban[ins.kelompok === 'Z' ? 'catatan' : 'k_kinerja_opsi_psp'] = this.form[ins.k_kinerja_instrumen_psp];

        instrumen.push(jawaban);
      }

      return instrumen;
    },

    onNext() {
      if (!this.isEdit) {
        if (this.page === this.kelompoks.length) {
          this.$emit('close');
          return;
        }

        this.$emit('next', this.page + 1);
        return;
      }

      this.validate();

      const errors = Object.values(this.error || {});
      const isError = errors.filter((err) => err).length > 0;
      if (isError) {
        if (this.error['kelompok-z']) {
          this.$error('Isikan jawaban minimal 10 kata dan maksimal 100 kata');
          return;
        }

        this.$error('Pastikan Anda menjawab semua pertanyaan yang telah disediakan');
        return;
      }

      if (this.page === this.kelompoks.length) {
        this.$emit('save');
        return;
      }

      this.$emit('next', this.page + 1);
    },

    onPrev() {
      this.$emit('prev', this.page - 1);
    },
  },
};
</script>

<style scoped>
.justify-center >>> .v-input--selection-controls__input {
  margin: 0 !important;
}

.flex-grow-1 >>> .v-input--selection-controls {
  margin-top: 0 !important;
}
</style>
